export const PORTAL_FRONTEND_VERSION = '2.35.3';
export const ADMIN_FRONTEND_VERSION = '1.2.0';
